import { useThemeMode } from '../theme/ThemeProvider';
import { iconRegistry } from '../assets/icons';

/**
 * Gets the URL for an SVG icon.
 *
 * @param iconName - The name of the icon (must be registered in iconRegistry)
 * @param mode - Optional theme mode override ('light' | 'dark')
 * @returns A URL string to the SVG file
 */
export const loadSvgIcon = (
  iconName: string,
  mode?: 'light' | 'dark'
): string => {
  const themeMode =
    mode || (localStorage.getItem('themeMode') as 'light' | 'dark') || 'light';

  const iconEntry = iconRegistry[iconName];
  if (!iconEntry) {
    throw new Error(`SVG icon not found in registry: ${iconName}`);
  }

  if (themeMode === 'dark' && iconEntry.dark) {
    return iconEntry.dark;
  }
  return iconEntry.light;
};

/**
 * React hook to get the URL for an SVG icon with theme detection.
 *
 * @param iconName - The name of the icon (must be registered in iconRegistry)
 * @returns The static file URL string for the icon
 *
 */
export const useSvgIcon = (iconName: string): string => {
  const { mode } = useThemeMode();
  return loadSvgIcon(iconName, mode);
};
